import { render, staticRenderFns } from "./cp_infoContent.vue?vue&type=template&id=1ef5fb90"
import script from "./cp_infoContent.vue?vue&type=script&lang=js"
export * from "./cp_infoContent.vue?vue&type=script&lang=js"
import style0 from "./cp_infoContent.vue?vue&type=style&index=0&id=1ef5fb90&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports